import { ErrorMap } from '@/types/domains/Error'

export const EmployeeInviteErrorMapping: ErrorMap = {
  'uc_create_user_employee_invite::email::taken': () => 'E-mail já convidado'
}
